import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MARKET } from "@/lib/format";
import { sized } from "@/lib/content";
import { Img } from "@/components/public/ui";
import { cn } from "@/lib/utils";

/* Project tile: image with a small market tag, then meta, title and one line. */
export const ProjectTile = ({ project, className = "", large = false, priority = false, dark = false, ratio }) => (
  <Link to={`/prosjekt/${project.slug}`} className={cn("group block", className)} data-testid="public-project-tile">
    <div className={cn("relative overflow-hidden rounded-2xl", dark ? "bg-white/5" : "bg-muted", ratio || (large ? "aspect-[4/3] sm:aspect-[16/9]" : "aspect-[4/3]"))}>
      <Img
        src={sized(project.hero_image, large ? 1800 : 1000)}
        alt=""
        sizes={large ? "100vw" : "(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"}
        loading={priority ? "eager" : "lazy"}
        className="tile-img img-premium h-full w-full object-cover"
      />
    </div>
    <div className="mt-4 flex items-start justify-between gap-4">
      <div className="min-w-0">
        <p className={cn("text-[13px]", dark ? "text-white/50" : "text-muted-foreground")}>{MARKET[project.market]} · {project.location} · {project.year}</p>
        <h3 className={cn("mt-1.5 font-display font-medium tracking-[-0.02em]", dark ? "text-white" : "text-foreground", large ? "text-2xl sm:text-3xl" : "text-[1.25rem] leading-snug")}>{project.title}</h3>
        <p className={cn("mt-1.5 text-[14.5px] leading-snug", dark ? "text-white/65" : "text-muted-foreground", large && "max-w-2xl")}>{project.subtitle}</p>
      </div>
      <ArrowUpRight className={cn("link-diag mt-1.5 h-6 w-6 shrink-0 transition-colors", dark ? "text-white/40 group-hover:text-white" : "text-foreground/40 group-hover:text-foreground")} strokeWidth={1.5} aria-hidden />
    </div>
  </Link>
);

/* Project row: year, title, client. */
export const ProjectRow = ({ project, className = "" }) => (
  <li className={cn("border-t border-border", className)}>
    <Link to={`/prosjekt/${project.slug}`} className="group grid grid-cols-[6.5ch_1fr_auto] items-baseline gap-4 py-4" data-testid="public-project-row">
      <span className="tabular text-[13px] text-muted-foreground">{String(project.year).split("–")[0].replace(/-$/, "")}</span>
      <span className="min-w-0">
        <span className="block text-[16px] font-medium text-foreground transition-colors group-hover:text-brand">{project.title}</span>
        <span className="mt-0.5 block text-[13.5px] leading-snug text-muted-foreground">{project.client} · {project.location}</span>
      </span>
      <ArrowUpRight className="h-4 w-4 self-center text-foreground/30 transition-colors group-hover:text-foreground" aria-hidden />
    </Link>
  </li>
);
